import { ReactElement } from 'react';
import { Case, CaseProps } from './Case';
import { Default } from './Default';

export function isCase(child: ReactElement): child is ReactElement<CaseProps> {
  return child.type === Case;
}

export function isDefault(child: ReactElement): child is ReactElement {
  return child.type == Default;
}
